import { DEAL_TYPES, PROMO_CODE_TYPES } from '../../../../../services/exports/Constants';

export default {
  title: 'Erikoistarjoukset',
  view_more: 'Näytä lisää',
  badges: {
    PROMO: 'Promo',
    DEAL: 'Tarjous',
    'FREE ITEM': 'Ilmainen tuote',
    REWARDS: 'Palkinnot',
  },
  deals: {
    [DEAL_TYPES.GOOGLE_REVIEW_PROGRAM]: {
      title: '+{{reward}} ylimääräistä pistettä',
      description: 'Arvioi meidät Googlessa',
    },
    [DEAL_TYPES.SMART_PRICING_RULE]: {
      title: 'Erikoistarjous',
      description: 'Jo automaattisesti käytössä',
    },
    buttons: {
      add: 'Lisää',
      remove: 'Poista',
      show_details: 'Näytä tiedot',
    },
    mobile_app_signup_bonus: {
      title: '{{amount}} sovelluksen rekisteröitymisbonus',
      desc: 'Saat {{amount}} käteispalautusta, kun kirjaudut sovellukseemme.',
    },
    welcome_bonus: {
      title: '{{amount}} tervetuliaisbonus',
      desc: 'Saat {{amount}} käteispalautusta rekisteröitymällä.',
    },
  },
  discounts: {
    title: '{{discount}} alennus',
    usage_threshold: '(Väh: {{amount}})',
    description: {
      [PROMO_CODE_TYPES.ONE_TIME_PROMO_CODE]: '{{discount}} alennus seuraavasta tilauksestasi - koodi: {{code}}',
      [PROMO_CODE_TYPES.MULTI_PROMO_CODE]: '{{discount}} alennus seuraavasta {{count}} tilauksesta - koodi: {{code}}',
    },
  },
  feedback: {
    login:
      '<highlight>Kirjaudu sisään</highlight> käyttääksesi tätä tarjousta, jotta voimme varmistaa, ettet ole käyttänyt sitä vielä. Kirjaudu sisään ja yritä uudelleen.',
  },
};
